import { render, staticRenderFns } from "./TgBetId.vue?vue&type=template&id=2411601f"
import script from "./TgBetId.vue?vue&type=script&lang=js"
export * from "./TgBetId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports